function createUniqueId(): string {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const currentYear = new Date().getFullYear();
    const yearChar = String.fromCharCode(65 + ((currentYear - 2025) % 26));
    const monthChar = String.fromCharCode(65 + new Date().getMonth());
    const randomDigit = () => Math.floor(Math.random() * 10);
    const randomLetter = () => characters[Math.floor(Math.random() * characters.length)];
    return yearChar + monthChar + randomDigit() + randomLetter() + randomDigit() + randomLetter();
}

export { createUniqueId };
